import { render } from "./AddActualiteModal.vue?vue&type=template&id=ed718e6a&scoped=true&ts=true"
import script from "./AddActualiteModal.vue?vue&type=script&lang=ts"
export * from "./AddActualiteModal.vue?vue&type=script&lang=ts"

import "./AddActualiteModal.vue?vue&type=style&index=0&id=ed718e6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed718e6a"]])

export default __exports__